import React, { Component } from 'react';
import { translate } from 'react-i18next';

import Layout from 'components/Layout/Layout';

class Search extends Component {

  render() {
    return (
      <div className='app-container'>
        <Layout history={this.props.history} option='search' />
      </div>
    );
  }
}

export default translate()(Search);
